import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import EnumerationListBoxViewModelType from '@/ViewModels/Controls/EnumerationListBoxViewModel';
import SelectBoxType from '@/Controls/SelectBox';

export default class EnumerationListBox extends Control {

    private SelectBox = ComponentManager.getControl<typeof SelectBoxType>('SelectBox');
    private jQueryControl: JQuery;
    private selectBox: SelectBoxType;

    public constructor(private viewModel: EnumerationListBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'enumerationlistbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            parentLocator: this.viewModel.parentLocator,

            locator: this.viewModel.locator,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.selectBox != null) {
            this.selectBox = new this.SelectBox(this.viewModel.selectBox);
            let tuple = this.selectBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        this.applyBindings(this.jQueryControl, {
            interact: this.viewModel.isEnabled
        });
    }
}

ComponentManager.setControl('EnumerationListBox', EnumerationListBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');